import {AdvancedTable, useAdvancedTable, useFilterContext} from '@eitje/web_components'
import {SearchFirmRowDropdown} from './components'
import {TABLE_INFO} from './constants'
import {columns} from './columns'

export const FirmsAdvancedTable = () => {
	'use no memo' // @tanstack/react-table is not compatible with the react compiler
	const {items} = useFilterContext()
	const tableData = useAdvancedTable({data: items, columns, TABLE_INFO})

	return <AdvancedTable data={tableData} RowDropdownItems={SearchFirmRowDropdown} />
}
